const normalizePath = (path: string) => path.replace(/^\/+/, "");

/**
 * Builds a URL for files served from the public directory.
 * PUBLIC_URL is set to the Apache application folder during production builds.
 */
export const assetUrl = (path: string): string => {
  const normalizedPath = normalizePath(path);
  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const publicPath =
    process.env.NODE_ENV === "production" && normalizedPath.startsWith("icons/")
      ? `assets/${normalizedPath}`
      : normalizedPath;

  return publicUrl
    ? `${publicUrl}/${publicPath}`
    : `/${publicPath}`;
};

const apiOrigin = (): string | null => {
  const apiServer = process.env.REACT_APP_API_SERVER;
  if (!apiServer) return null;

  try {
    return new URL(apiServer).origin;
  } catch {
    return null;
  }
};

/**
 * Resolves image paths returned by the API without disturbing absolute URLs,
 * data URLs, or local object URLs created for file previews.
 */
export const imageUrl = (
  path: string | null | undefined,
  fallback = assetUrl("images/empty-doctor.png")
): string => {
  if (!path) return fallback;
  if (/^(https?:|data:|blob:|\/\/)/i.test(path)) return path;

  const origin = apiOrigin();
  return origin ? `${origin}/${normalizePath(path)}` : assetUrl(path);
};

export const defaultAvatarUrl = (): string => {
  const origin = apiOrigin();
  return origin
    ? `${origin}/image/avatar/user.png`
    : assetUrl("images/empty-doctor.png");
};
